module.exports = __webpack_public_path__ + "media/images/bnr_special_umibe-06ceada066b7a651ecb62e133056dea9.jpg";